import "./DataMapping.scss"
import React from "react";
import {observer} from "mobx-react-lite";
import {Grid, Typography} from "@mui/material";
import {useStores} from "../../../stores";
import {CurrencyComponent} from "../../../components/currency-component/CurrencyComponent";
import {MappingResultTable} from "./MappingResultTable";

export const DatasetCheck: React.FC = observer(() => {

    const {dataIngestionStore} = useStores();


    return (
        <Grid className="data-check-wrapper" justifyContent="center">
            <Grid container
                  className="dashboard"
                  justifyContent="space-evenly"
                  spacing={0}>
                <DataMappingResultSpendRow
                    title="Spend"
                    className="categories-row"
                    amount={dataIngestionStore.dataMappingResultKpi?.total_spend}>
                </DataMappingResultSpendRow>
                <DataMappingResultRow
                    title="Suppliers"
                    className="spend-row"
                    subtitle={dataIngestionStore.dataMappingResultKpi?.suppliers}>
                </DataMappingResultRow>
                <DataMappingResultRow
                    title="Parts"
                    className="suppliers-row"
                    subtitle={dataIngestionStore.dataMappingResultKpi?.parts}>
                </DataMappingResultRow>
                <DataMappingResultRow
                    title="Business Units"
                    className="business-units-row"
                    subtitle={dataIngestionStore.dataMappingResultKpi?.business_units}>
                </DataMappingResultRow>
            </Grid>

            <Grid container justifyContent="space-evenly" className="data-check-table">
                <Grid size={12}>
                    <MappingResultTable/>
                </Grid>
            </Grid>
        </Grid>
    );
})


type RowProps = {
    className: string
    title: string
    subtitle: React.ReactNode
    children?: React.ReactNode
}

type spendProps = {
    className: string
    title: string
    amount?: number
    children?: React.ReactNode
}
const DataMappingResultRow: React.FC<RowProps> = ({className, title, subtitle, children}) =>
    <Grid
        className={`dashboard-row ${className}`}
        size={{
            lg: 3,
            xs: 4
        }}>
        <Grid container direction="column" alignItems="center">
            <Grid className="dashboard-row-title">
                <Typography variant="h2" component="h2">
                    {title}
                </Typography>
            </Grid>
            <Grid className="dashboard-row-subtitle">
                <Typography variant="subtitle2" component="h2">
                    {subtitle}
                </Typography>
            </Grid>
        </Grid>
        <Grid container justifyContent="center">
            <Grid
                className="dashboard-row-content"
                size={{
                    sm: 11,
                    xs: 12
                }}>
                {children}
            </Grid>
        </Grid>
    </Grid>

const DataMappingResultSpendRow: React.FC<spendProps> = ({className, title, amount, children}) =>
    <Grid
        className={`dashboard-row ${className}`}
        size={{
            lg: 3,
            xs: 4
        }}>
        <Grid container direction="column" alignItems="center">
            <Grid className="dashboard-row-title">
                <Typography variant="h2" component="h2">
                    {title}
                </Typography>
            </Grid>
            <Grid className="dashboard-row-subtitle">
                <Typography variant="subtitle2" component="h2">
                    {amount !== undefined ? <CurrencyComponent v={amount}></CurrencyComponent> : null}
                </Typography>
            </Grid>
        </Grid>
        <Grid container justifyContent="center">
            <Grid
                className="dashboard-row-content"
                size={{
                    sm: 11,
                    xs: 12
                }}>
                {children}
            </Grid>
        </Grid>
    </Grid>
